"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultProviderTheme = exports.defaultThemeObject = exports.defaultThemeMetadata = exports.defaultTheme = void 0;
exports.defaultTheme = {
    type: "dark",
    primary: "#34d867",
    secondary: "#2b7ae1",
    tertiary: "#FFFF00",
    background: "#1B1B1B",
    warning: "#d2ac00",
    error: "#FF0000",
    text: {
        primary: "#F4F4F4",
        secondary: "#b8b8b8",
    },
    backgroundColor: {
        default: "#242424",
        dark: "#262626",
        light: "#333333",
        contrast: "#666666",
    },
    mobBackground: {
        background: '#1B1B1B',
        backgroundLight: '#525252',
        backgroundOverlay: '#3D3D3D',
        card: '#575757'
    },
    logo: "https://mfw-stage.s3.eu-central-1.wasabisys.com/mfw-stage.appspot.com/next.myfitworld.net/logo/dark/image.png",
};
exports.defaultThemeMetadata = {
    orgId: "5BeUsYXvwxckki8hpxLS",
    domain: "next.myfitworld.net",
    whitelabel: {
        name: "Myfitworld",
        supportEmail: "support@myfitworld.net",
        netName: "MFWNet",
        isWlNetActive: true,
        loginSlideshow: [
            "https://s3.eu-central-1.wasabisys.com/mfw-prod/mfw-prod.appspot.com/theme/WEB/login_slideshow/Image01.jpg",
        ],
        haveMFWContent: true,
        s3ThemePath: ""
    },
    appStoreLink: {
        google: "https://play.google.com/store/apps/details?id=net.myfitworld.app&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1",
        apple: "https://apps.apple.com/us/app/myfitworld/id1530209534",
        huawei: "https://appgallery.huawei.com/#/app/C104537149"
    }
};
exports.defaultThemeObject = __assign(__assign({}, exports.defaultThemeMetadata), { theme: {
        light: exports.defaultTheme,
        dark: exports.defaultTheme,
    } });
exports.defaultProviderTheme = __assign(__assign({}, exports.defaultThemeMetadata), { theme: exports.defaultTheme, isWhiteLabel: false });
//# sourceMappingURL=defaultTheme.js.map